import adminRoutes from 'csam/adminRoutes';
import Layout from 'csam/components/Layout';
import DataProtection from 'csam/pages/DataProtection';
import { lazy, useEffect } from 'react';
import { createBrowserRouter, Navigate, useLocation, useNavigate } from 'react-router-dom';
import TrainingPlatform from 'csam/pages/TrainingPlatform';
import TrainingPlatformAs from './pages/TrainingPlatformAS';
import OctPishingContest from './pages/OctPishingContest';
import OctGameSingle from './pages/OctGameSingle';
import UnderstandingGisp from './pages/UnderstandingGisp';
import GispPosterView from './pages/GispPosterView';
import CyberChallenge from './pages/CyberChallenge';
import { useAdminAuthorized } from './api/api';
import PosterGoLive from './pages/PosterGoLive';
import TrainingPlatformBrewstars from './pages/TrainingPlatformBrewstars';

const Archives = lazy(() => import('csam/pages/Archives'));
const Gamecontests = lazy(() => import('csam/pages/GameContest'));
const Goodreads = lazy(() => import('csam/pages/GoodReads'));
// const Homepage = lazy(() => import('csam/pages/Home'));
const Monthbanner = lazy(() => import('csam/pages/MonthBanner'));
const Toolsresources = lazy(() => import('csam/pages/ToolsResources'));
const ComingSoon = lazy(() => import('csam/pages/ComingSoon'));
const Leaderboard = lazy(() => import('csam/pages/Leaderboard'));
const Maintenance = lazy(() => import('csam/pages/Maintenance'));
const GameSingle = lazy(() => import('csam/pages/GameSingle'));
const PageNotFound = lazy(() => import('csam/pages/PageNotFound'));
const InternalServerError = lazy(() => import('csam/pages/InternalServerError'));
const QuizSingle = lazy(() => import('csam/pages/QuizSingle'));
const Opps = lazy(() => import('csam/pages/Opps'));
const PrivacyPolicy = lazy(() => import('csam/pages/PrivacyPolicy'));
const OctMonth = lazy(() => import('csam/pages/OctMonth'));
const OctActivities = lazy(() => import('csam/pages/OctActivities'));
const HomeNew = lazy(() => import('csam/pages/HomeNew'));
const AllTrainings = lazy(() => import('csam/pages/AllTrainings'));
const TrainingReports = lazy(() => import('csam/pages/TrainingReports'));
const GalleryPage = lazy(() => import('csam/pages/GalleryPage'));
const FalseLogin = lazy(() => import('csam/pages/FalseLogin'));
const AbiLogin = lazy(() => import('csam/pages/AbiLogin'));
const SecondaryAbiLogin = lazy(() => import('csam/pages/SecondaryAbiLogin'));
const AbiLogin3 = lazy(() => import('csam/pages/AbiLogin3'));
const ABIlogin4 = lazy(() => import('csam/pages/ABIlogin4'));
const SecondaryOops = lazy(() => import('csam/pages/SecondaryOops'));
const GoodReadsNew = lazy(() => import('csam/pages/GoodReadsNew'));
const ToolsResourcesNew = lazy(() => import('csam/pages/ToolsResourcesNew'));
const ThemeOfTheMonth = lazy(() => import('csam/pages/ThemeOfTheMonth'));
const LeaderboardNew = lazy(() => import('csam/pages/LeaderboardNew'));
const Login_api = lazy(() => import('csam/api/Login_api'));
const FifaTheme = lazy(()=> import('csam/pages/FifaPage'))
const FifaInsights= lazy(()=> import('csam/components/FifaInsights'))
const TrainingCompletionDashboard = lazy(()=> import('csam/pages/PhishingTrainingreport'))
const RestrictedRoute = ({ children }) => {
  const { isAdmin, isLoading } = useAdminAuthorized();
  const navigate = useNavigate();
  const location = useLocation();

  // Define maintenance mode (moved outside of useEffect to make it clearly accessible)
  const MAINTENANCE_MODE = true;
  const currentPath = location.pathname;
  const isOnPosterPage = currentPath.includes('/poster-page');

  // Use a separate effect specifically for the initial check and redirect
  useEffect(() => {
    // Only run this once on initial load and when isAdmin status is determined
    if (!isLoading && MAINTENANCE_MODE && !isAdmin && !isOnPosterPage) {
      const locale = currentPath.split('/')[1] || 'en';
      navigate(`/${locale}/poster-page`, { replace: true });
    }
  }, [isLoading]); // Only run when loading state changes

  // This effect runs on every path change after initial load
  useEffect(() => {
    if (!isLoading && MAINTENANCE_MODE && !isAdmin && !isOnPosterPage) {
      const locale = currentPath.split('/')[1] || 'en';
      navigate(`/${locale}/poster-page`, { replace: true });
    }
  }, [location.pathname, isAdmin, isLoading]);

  // In maintenance mode, if user is not admin and not on poster page, render PosterGoLive directly
  if (MAINTENANCE_MODE && !isLoading && !isAdmin && !isOnPosterPage) {
    return null; // Return nothing, redirect will happen
  }

  // If loading, show a loader
  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (MAINTENANCE_MODE && !isAdmin && !isOnPosterPage) {
    const locale = currentPath.split('/')[1] || 'en';
    return <Navigate to={`/${locale}/poster-page`} replace />;
  }

  // Otherwise, render children
  return children;
};


const routes = [
  {
    path: '/',
    element: <Navigate to="/en" />,
  },
  // {
  //   path: '/:locale/poster-page',
  //   element: <PosterGoLive />,
  // },
  {
    path: '/:locale',
    // element: <RestrictedRoute><Layout /></RestrictedRoute>,
    element : <Layout />,

    children: [
      {
        index: true,
        element: <HomeNew />,
      },
      {
        path: 'good-reads',
        element: <GoodReadsNew />,
      },
      {
        path: 'tools-resources',
        element: <ToolsResourcesNew />,
      }, {
        path: 'leaderboard',
        element: <LeaderboardNew />,
      },
      {
        path: 'theme-of-the-month',
        element: <ThemeOfTheMonth />,
      },
       {
        path: 'Fifa-theme',
        element: <FifaTheme />,
      },
      {
        path: 'Fifa-insights',
        element: <FifaInsights />,
      },
      {
        path: 'cyber-challenge',
        element: <CyberChallenge />,
      },
      {
        path: 'false-login',
        element: <FalseLogin />,
      },
      {
        path: ':templateId?/abi-login-1',
        element: <AbiLogin />,
      },
      {
        path: 'abi-login-2',
        element: <SecondaryAbiLogin />,
      },
      {
        path: 'abi-login-3',
        element: <AbiLogin3 />,
      },
      {
        path: 'abi-login-4',
        element: <ABIlogin4 />,
      },
      {
        path: 'Monthbanner',
        element: <Monthbanner />,
      },
      {
        path: 'Goodreads',
        element: <Goodreads />,
      },
      {
        path: 'Gamecontests',
        element: <Gamecontests />,
      },
      {
        path: 'training-platform',
        element: <TrainingPlatform />,
      },
      {
        path: 'application-security',
        element: <TrainingPlatformAs />,
      },
      {
        path: 'cyber-training-reports',
        element: <TrainingReports />,
      },
      {
        path: 'training-thanks',
        element: <TrainingPlatform />,
      },
      {
        path: 'appsec-thanks',
        element: <TrainingPlatformAs />,
      },
      {
        path: 'phishing-training-thanks',
        element: <TrainingPlatformBrewstars />,
      },
      {
        path: ':training_id/phishing-training-thanks',
        element: <TrainingPlatformBrewstars />,
      },

       {
        path: 'brewstars',
        element: <TrainingPlatformBrewstars />,
        
      },
      {
        path: 'contest',
        element: <Gamecontests />,
      },
      {
        path: 'Toolsresources',
        element: <Toolsresources />,
      },
      {
        path: 'Archives',
        element: <Archives />,
      },
      {
        path: 'Leaderboard-old',
        element: <Leaderboard />,
      },
      {
        path: 'internal-server-error',
        element: <InternalServerError />,
      },
      {
        path: '/:locale/*',
        element: <PageNotFound />,
      },
      {
        path: '*',
        element: <Navigate to="/en/404" replace />,
      },
      {
        path: 'maintenance',
        element: <Maintenance />,
      },
      {
        path: 'comming-soon',
        element: <ComingSoon />,
      },
      {
        path: 'comming-soon-data-protection',
        element: <ComingSoon />,
      },
      {
        path: 'login',
        element: <Login_api />,
      },
      {
        path: 'data-protection',
        element: <DataProtection />,
      },
      {
        path: 'game-page',
        element: <GameSingle />,
      },
      {
        path: 'play-quiz',
        element: <QuizSingle />,
      },
      {
        path: 'oops-1',
        element: <Opps />,
      },
      {
        path: 'oops-2',
        element: <SecondaryOops />,
      },
      {
        path: '2026',
        element: <OctMonth />,
      },
      {
        path: '2026/activity',
        element: <OctActivities />,
      },
      {
        path: '2026/oct-phisihing-contest',
        element: <OctPishingContest />,
      },
      {
        path: '2026/oct-game-page',
        element: <OctGameSingle />,
      },
      {
        path: 'understanding-gisp',
        element: <UnderstandingGisp />,
      },
      {
        path: 'gisp-Poster',
        element: <GispPosterView />,
      },
      {
        path: 'home-new',
        element: <HomeNew />,
      },
      {
        path: 'gallery',
        element: <GalleryPage />,
      },
      {
        path: 'trainings',
        element: <AllTrainings />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
      },
      {
        path: 'Training-Report',
        element: <TrainingCompletionDashboard />,
      },
    ],
  },
  ...adminRoutes,
];

const router = createBrowserRouter(routes);

export default router;
